import { useEffect, useState } from "react";
import { url } from "../App";

const useBanner = () => {
    const [bannerItems, setBannerItems] = useState([]);
    useEffect(() => {
        // GET request using fetch inside useEffect React hook
        fetch(`${url}/banner/`)
            .then(response => response.json())
            .then(jsonData => {
                // console.log(jsonData);
                setBannerItems(jsonData);
            });
    
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, []);
    return {
        bannerItems,
    };
};

export default useBanner;